import React, { FC, useState } from 'react';
import { CLAIM_ACCOUNT_STEP, ModalStepProps } from '../types';
import SelectCountry from './SelectCountry';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import { getAccessToken, parseJwt } from '../../../utils';

type Props = ModalStepProps;

const ModalBody: FC<Props> = ({ step, setStep }) => {
  const [instance, setInstance] = useState<Record<string, any> | null>(null);
  const token = getAccessToken();
  const { id: migratedAccountID } = parseJwt(token);

  switch (step) {
    case CLAIM_ACCOUNT_STEP.SELECT_COUNTRY:
      return <SelectCountry setStep={setStep} setInstance={setInstance} />;
    case CLAIM_ACCOUNT_STEP.LOGIN:
      return <Login instance={instance} setStep={setStep} token={token} migratedAccountID={migratedAccountID} />;
    case CLAIM_ACCOUNT_STEP.FORGOT_PASSWORD:
      return <ForgotPassword instance={instance} migratedAccountID={migratedAccountID} />;
    default:
      return null;
  }
};

export default ModalBody;
